<div class="answer" data-test="answer">

  <!-- prompt -->
  <div class="answer__prompt">

    <!-- numbering: optional -->
    <div *ngIf="questionNumber" class="mr-1">{{ questionNumber }}.</div>

    <div>
      <app-content-blocks [contentBlocks]="question.questionPrompt"></app-content-blocks>
    </div>
    
  </div>

  <!-- question specific response(s) -->
  <div [ngSwitch]="question.type">

    <!-- Multiple Choice -->
    <div *ngSwitchCase="QuestionType.MultipleChoice">

      <app-view-quiz-multiple-choice-answer [question]="question" [answer]="answer" [summary]="summary">        
      </app-view-quiz-multiple-choice-answer>

    </div>

    <!-- Select Anatomy -->
    <div *ngSwitchCase="QuestionType.SelectAnatomy">

      <app-view-quiz-select-anatomy-answer [question]="question" [answer]="answer" [summary]="summary">        
      </app-view-quiz-select-anatomy-answer>

    </div>

    <!-- Label Anatomy -->
    <div *ngSwitchCase="QuestionType.LabelAnatomy">

      <app-view-quiz-label-anatomy-answer [question]="question" [answer]="answer" [summary]="summary">        
      </app-view-quiz-label-anatomy-answer>

    </div>

  </div>

  <!-- explanation -->
  <div class="answer__explanation">
    <app-content-blocks [contentBlocks]="question.explanation"></app-content-blocks>
  </div>

</div>